import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars,faHome,faChild,faCog } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../context';

const SideBar = ({ item, img, name }) => {

  const { menu,setMenu } = useGlobalContext();

  const menuExpand = () => {
    let newMenu = !menu
    setMenu(newMenu)
    if(menu === true){
      console.log('open menu');
    } else {
      console.log('close menu');
    }
  }

  return (
    <>
      <div className="SideIcon" id="fabars" onClick={() => menuExpand()}>
        <FontAwesomeIcon icon={faBars} />
      </div>
      <div className={`${menu ? 'menuClosed' : 'menuOpen'}`}>
        <div className="TopIcons">
          <Link to="/">
            <div className={`${menu ? 'SelectedSideIcon' : 'SelectedSideIcon-Open'}`}>
              <FontAwesomeIcon icon={faHome} id="faHome" />
              <div>Home</div>
            </div>
          </Link>
          <Link to="/DeckPal">
            <div className={`${menu ? 'SideIcon' : 'SideIcon-Open'}`}>
              <FontAwesomeIcon icon={faChild} id="faChild" />
              <div>DeckPal</div>
            </div>
          </Link>
        </div>
        <div className="BottomIcons">
          <div className={`${menu ? 'SideIcon' : 'SideIcon-Open'}`}>
            <FontAwesomeIcon icon={faCog} id="faCog" />
            <div>Settings</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
